import { Avatar } from '@chakra-ui/react';
import { StarsIcon } from 'components/icons';

const BotAvatar = () => {
  return <Avatar bg="linear-gradient(90deg, #04C3CC -0.81%, #527BE4 40.47%, #A373EB 100%)" icon={<StarsIcon />} />;
};

export default BotAvatar;
